import React from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';
import Load from 'components/Load';
import Notfound from 'modules/errorpages/Notfound';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import { Translator } from 'Translator';
import LoadingDots from 'components/LoadingDots';
import LoggedOut from 'modules/user-environment2/components/LoggedOut';
import useCandidateProcess from 'hooks/useCandidateProcess';
import {useUser} from "~/authentication/store";

const AsyncOverviewPage = Load(() => import(/* webpackChunkName: "learning-center-overview" */'./components/OverviewPage'));
const AsyncCollectionPage = Load(() => import(/* webpackChunkName: "learning-center" */'./containers/CollectionPageContainer'));
const AsyncPreviewPage = Load(() => import(/* webpackChunkName: "learning-center" */'./components/PreviewPage'));
const AsyncSingleArticlePage = Load(() => import(/* webpackChunkName: "learning-center" */'./components/SingleArticlePage'));
const AsyncPreviewCollectionPage = Load(() => import(/* webpackChunkName: "learning-center" */'./components/PreviewCollectionPage'));
const AsyncVideoArticlePAge = Load(() => import(/* webpackChunkName: "learning-center" */'./containers/VideoArticlePageContainer'));
const AsyncCoursePage = Load(() => import(/* webpackChunkName: "learning-center-course" */'./containers/CoursePageContainer'));

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { isCandidate, loading: processLoading } = useCandidateProcess();
  const { isLoggedIn, isHost, isAdmin, loading } = useUser();
  if (!loading && !isLoggedIn) {
    return (
      <LoggedOut title={'Login to view this content'} />
    );
  }

  if (loading || processLoading) {
    return (
      <LoadingDots />
    );
  }
    
  if (!isHost && !isAdmin && !isCandidate) {
    return (
      <Redirect to={generatePathnameWithLangCode('/', Translator.getLanguageCode())}/>
    );
  }

  return (
    <Switch>
      <NavigationableLayout
        path={`${path}/course-details/:id`}
        hideFooter
        component={AsyncCoursePage}
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/video/:id`}
        hideFooter
        component={AsyncVideoArticlePAge}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/:category/:id`}
        hideFooter
        component={AsyncCollectionPage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/article/:category/:id`}
        hideFooter
        component={AsyncSingleArticlePage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/preview-article/:category/:id`}
        hideFooter
        component={AsyncPreviewPage}
        noNavbar={isCordova()}
        nonFixedNavbar
      />
      <NavigationableLayout
        exact
        path={`${path}/preview-collection/:id`}
        hideFooter
        component={AsyncPreviewCollectionPage}
        noNavbar
        nonFixedNavbar
      />
      <NavigationableLayout
        path={path}
        hideFooter
        component={AsyncOverviewPage}
        noNavbar={isCordova()}
        nonFixedNavbar
      />
      <Route>
        <Notfound />
      </Route>
    </Switch>
  );
};

const routes =
  <Route path={`${basePath}/learning-center`}>
    <>
      <SubRoutes />
      <AppBottomPushDown/>
    </>
  </Route>;


export default routes;
